// 会员级别
export const vipLevel = state => state.vipLevel
export const phone = state => state.phone
export const person= state => {
	return {
		avatar: state.avatar, // 头像
		birth: state.birth, // 生日
		companyPosition: state.companyPosition,
		defaultUserName: state.defaultUserName,
		userName: state.userName,
		userId: state.userId,
		companyName: state.companyName // 公司名称
	}
}
export const formattedMobile = state =>  state.formattedMobile  // 初始账号
export const policyRemind= state => state.policyRemind // app政策小秘书提醒
export const policySecretary = state => state.policySecretary // 政策小秘书提醒
export const policySecretaryNum = state =>state.policySecretaryNum // 政策新增次数
export const policyExpertOnline = state => state.policyExpertOnline // 专家是否在线
export const policyLeftVisitTimes = state => state.policyLeftVisitTimes
export const policyExpertLeftTimes = state => state.policyExpertLeftTimes // 专家咨询剩余次数
export const vipEndTime= state => state.vipEndTime  // 会员兑换码兑换到期时间
export const timeLenStr= state => state.timeLenStr  // 会员兑换码兑增加天数
export const noVipPolicyDayVisitTimes = state => state.noVipPolicyDayVisitTimes //  非会员可免费查看天数
export const availableCouponNum = state => state.availableCouponNum  // 可用优惠券
export const notAvailableCouponNum = state => state.notAvailableCouponNum // 不可用优惠券
export const messageList = state => state.messageList  // 消息列表
export const defaultUserName = state => state.defaultUserName  // 是否是默认电话


